import * as api from '../dealerApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  dealerActionCreators,
  DealerActionKeys,
  FetchDealerFinancials,
  IDealerFinancialSummary
  } from '..';

function* fetchDealerFinancialsSaga(action: FetchDealerFinancials) {
  yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload, type: 'financials' }));
  const financials: IDealerFinancialSummary[] = yield call(api.fetchFinancials, action.payload);

  yield put(dealerActionCreators.setFinancials(financials));
  yield put(dealerActionCreators.toggleLoading({ accountNum: action.payload, type: 'financials' }));
}

export function* watchFetchDealerFinancials() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_FINANCIALS, fetchDealerFinancialsSaga);
}
